import { render, staticRenderFns } from "./ManageRoom.vue?vue&type=template&id=33203c71"
import script from "./ManageRoom.vue?vue&type=script&lang=js"
export * from "./ManageRoom.vue?vue&type=script&lang=js"
import style0 from "./ManageRoom.vue?vue&type=style&index=0&id=33203c71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports